import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { Helper } from "../core/util/helper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { FAIcon } from "../core/components/faIcon";
import { Button } from "../core/components/button";
import { DialogHelper } from "../core/util/dialogHelper";
import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import { EditMobileUserSettings } from "./editMobileUserSettings";
import { ResourceAppProps } from "./resource";
import { Context, Metadata } from "../core/components/commonApp";
import React from "react";
export interface WindowsClientAppProps extends ResourceAppProps {
    handleFieldChange?: (field, value) => void;
}

export default class WindowsClient extends React.Component<WindowsClientAppProps, {
    windowsClientViewModel: WindowsClientViewModel;
}> {

    constructor(props) {
        super(props);
        this.state = {
            windowsClientViewModel: null
        }
    }

    componentDidMount() {
        this.init();
    }

    private init = async () => {
        let dataUrl = 'WindowsClient/InitWindowsClient?ressNr=' + encodeURIComponent(this.props.entity.Ressnr);
        let result = await HTTPService.get<JsonResultClass<WindowsClientViewModel>>(dataUrl);
        if (result.Code == 0) {
            let vm = result.Data;
            this.setState({ windowsClientViewModel: vm });
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private _handleActivate = async () => {
        let result = await HTTPService.post<JsonResultClass>("WindowsClient/Activate", { ressNr: this.props.entity.Ressnr })
        if (result.Code == 0) {
            this.init();
            this.props.handleFieldChange({model: "Useswindowsclient"}, true);
        }
        else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private _handleDeactivate = async () => {
        if (await DialogHelper.confirm(Helper.getTranslation("WebSMS.Resource.WindowsClientWirklichDeaktivieren"))) {
            let result = await HTTPService.post<JsonResultClass>("WindowsClient/Deactivate", { ressNr: this.props.entity.Ressnr })
            if (result.Code == 0) {
                let vm = this.state.windowsClientViewModel;
                vm.Status = MobileUserStatus.Deactivated;
                this.setState({ windowsClientViewModel: vm }, () => this.props.handleFieldChange({model: "Useswindowsclient"}, false));
            }
            else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
    }

    private _handleInitialize = async () => {
        let result = await HTTPService.post<JsonResultClass>("WindowsClient/Initialize", { ressNr: this.props.entity.Ressnr })
        if (result.Code == 0) {
            let vm = this.state.windowsClientViewModel;
            vm.Status = MobileUserStatus.IsActivating;
            this.setState({ windowsClientViewModel: vm }, () => this.props.handleFieldChange({model: "Useswindowsclient"}, true));
        }
        else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private _showNumberRangeSheet = async () => {
        const sheet = General.Sheet.Manager.createSheet();
        sheet.setTitle(Helper.getTranslation("Server.NumberRanges.SettingsOfTechnican"));
        sheet.bind(SheetEventType.SavedSuccessfully, (target) => {
            this.init();
        });
        const results = await Promise.all([
            HTTPService.get("WindowsClient/GetMobileUserSettings?ressNr=" + encodeURIComponent(this.props.entity.Ressnr)),
            Helper.getMetaData("editMobileUserSettings")
        ]);


        sheet.show(() => {
            const entity = results[0].Data;
            const metaData = results[1];
            const props = {
                dataSources: {},
                metadata: metaData as Metadata,
                entity: entity,
                isWindow: true,
                context: { contextType: "editMobileUser" } as Context
            };
            sheet.mountContent(EditMobileUserSettings, props);
        });
    }

    private _renderStatus = () => {
        let styleBorder: React.CSSProperties = { width: "50%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" };
        let styleLabel: React.CSSProperties = {};

        let labelStatus: string = null;
        if (this.state.windowsClientViewModel.Status == MobileUserStatus.Activated) {
            styleBorder = $.extend({}, styleBorder, { border: "1px solid #4caf50" });
            styleLabel = { color: "#4caf50" };
            labelStatus = Helper.getTranslation("Standard.Aktiviert");
        }
        else if (this.state.windowsClientViewModel.Status == MobileUserStatus.IsActivating) {
            labelStatus = Helper.getTranslation("Standard.AktivierungLaeuft");
            styleBorder = $.extend({}, styleBorder, { border: "1px solid #FB8C00" });
            styleLabel = { color: "#FB8C00" };
        }
        else if (this.state.windowsClientViewModel.Status == MobileUserStatus.Deactivated) {
            labelStatus = Helper.getTranslation("Standard.Deaktiviert");
            styleBorder = $.extend({}, styleBorder, { border: "1px solid #f44336" });
            styleLabel = { color: "#f44336" };
        }

        return (
            <div style={{ display: "flex", alignItems: "center", height: "30px" }}>
                <div style={{ width: "50%" }}>
                    <label>{Helper.getTranslation("Field.Adresse.status")}</label>
                </div>
                <div style={styleBorder}>
                    <label style={styleLabel}>{labelStatus}</label>
                </div>
            </div>
        );
    }

    private _renderExportPath = () => {
        if (this.state.windowsClientViewModel.Status == MobileUserStatus.Deactivated)
            return null;
        else {
            let icon = this.state.windowsClientViewModel.ExportPathExists ?
                <FAIcon name="check-circle" style={{ color: "#4caf50" }} attributes={["2x"]} /> :
                <FAIcon name="exclamation-circle" style={{ color: "#F44336" }} attributes={["2x"]} />;

            return (
                <div style={{ display: "flex", alignItems: "center", height: "30px", marginTop: "5px" }}>
                    <div style={{ width: "50%" }}>
                        <label>{Helper.getTranslation("Server.Settings.ExportPath")}</label>
                    </div>
                    <div onClick={Helper.throttle(this._showNumberRangeSheet)} style={{ width: "50%", display: "flex", alignItems: "center", justifyContent: "center" }} title={this.state.windowsClientViewModel.ExportPath} >
                        {icon}
                    </div>
                </div>
            );
        }
    }

    private _renderNumberRanges = () => {
        if (this.state.windowsClientViewModel.Status == MobileUserStatus.Deactivated)
            return null;
        else {
            let icon = this.state.windowsClientViewModel.NumberRanges.Code == 0 ?
                <FAIcon name="check-circle" style={{ color: "#4caf50" }} attributes={["2x"]} /> :
                <FAIcon name="exclamation-circle" style={{ color: "#F44336" }} attributes={["2x"]} />;

            let tooltip = "";
            for (let entry of this.state.windowsClientViewModel.NumberRanges.Messages) {
                tooltip += entry + "\n";
            }
            return (
                <div style={{ display: "flex", alignItems: "center", height: "30px", marginTop: "5px" }}>
                    <div style={{ width: "50%" }}>
                        <label >{Helper.getTranslation("Server.SendData.NrRanges")}</label>
                    </div>
                    <div onClick={Helper.throttle(this._showNumberRangeSheet)} style={{ width: "50%", display: "flex", alignItems: "center", justifyContent: "center" }} title={tooltip} >
                        {icon}
                    </div>
                </div>
            );
        }
    }

    private _renderLastReportReceived = () => {
        if (this.state.windowsClientViewModel.Status == MobileUserStatus.Deactivated)
            return null;
        else {
            return (
                <div style={{ display: "flex", alignItems: "center", height: "30px" }}>
                    <div style={{ width: "50%" }}>
                        <label>{Helper.getTranslation("WebSMS.Resource.LetzerBelegEmpfangen")}</label>
                    </div>
                    <div style={{ width: "50%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <label>{this.state.windowsClientViewModel.LastReportReceived != null ? kendo.toString(kendo.parseDate(this.state.windowsClientViewModel.LastReportReceived), 'g') : "-"}</label>
                    </div>
                </div>
            );
        }
    }

    private _renderButtons = () => {
        let btnActivate = this.state.windowsClientViewModel.Status == MobileUserStatus.Deactivated ? this.renderButtonActivate() : null;
        let btnDeactivate = this.state.windowsClientViewModel.Status != MobileUserStatus.Deactivated ? this.renderButtonDeactivate() : null;
        let btnInitialize = this.state.windowsClientViewModel.Status == MobileUserStatus.Activated ? this.renderButtonInitialize() : null;

        return <div>
            {btnActivate}
            {btnInitialize}
            {btnDeactivate}
        </div>
    }

    private renderButtonActivate = () => {
        return <Button buttonStyle={{ width: "fit-content", borderRadius: "var(--border-radius)" }} text={Helper.getTranslation("Standard.Aktivieren")} iconName="check" handleClick={this._handleActivate} readOnly={!this.state.windowsClientViewModel?.CanUseWindowsClient} />;
    }

    private renderButtonDeactivate = () => {
        return <Button buttonStyle={{ marginLeft: "5px", width: "fit-content", borderRadius: "var(--border-radius)" }} text={Helper.getTranslation("Standard.Deaktivieren")} iconName="ban" handleClick={this._handleDeactivate} readOnly={!this.state.windowsClientViewModel?.CanUseWindowsClient}/>;
    }

    private renderButtonInitialize = () => {
        return <Button buttonStyle={{ width: "fit-content", borderRadius: "var(--border-radius)" }} text={Helper.getTranslation("Standard.Initialisieren")} iconName="upload" handleClick={this._handleInitialize} readOnly={!this.state.windowsClientViewModel?.CanUseWindowsClient}/>;
    }

    private renderContent() {
        let warningCanUseWindowClient = !this.state.windowsClientViewModel?.CanUseWindowsClient ? <label>{Helper.getTranslation("WebSMS.Resource.ExportBasePathNotExists")}</label> : null;

        return <div>
            {warningCanUseWindowClient}
            {this._renderStatus()}
            {this._renderExportPath()}
            {this._renderNumberRanges()}
            {this._renderLastReportReceived()}

            <div style={{ marginTop: "5px", width: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                {this._renderButtons()}
            </div>
        </div>
    }

    render() {
        let content = Helper.hasValue(this.state.windowsClientViewModel) ? this.renderContent() : null;

        return (<>
            {content}
        </>);
    }
}

interface WindowsClientViewModel {
    Status?: MobileUserStatus;
    ExportPath?: string;
    ExportPathExists?: boolean;
    NumberRanges?: CheckNumberRangesResult;
    LastReportReceived?: string;
    CanUseWindowsClient?: boolean;
}

interface CheckNumberRangesResult {
    Code: number;
    Messages: Array<string>;
}

export enum MobileUserStatus {
    Activated,
    IsActivating,
    Deactivated
}